import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { GdprMessageWrapper, TextCallout2, UnderlineLink } from '../../style.js'

export const PRIVATE_GDPR_TEXT =
  'För att göra vår tjänst säker och trygg kan meddelanden komma att granskas och filtreras.'
export const COMPANY_GDPR_TEXT =
  'För att göra vår tjänst säker och trygg kan meddelanden som skickas komma att filtreras och granskas. Företaget som du nu kontaktar blir personuppgiftsansvarig för uppgifterna i meddelandet.'

export const ChannelGdprMessage = ({ type = 'private' }) => {
  const [text, setText] = useState('')

  useEffect(() => {
    switch (type) {
      case 'company' || 'store':
        return setText(COMPANY_GDPR_TEXT)
      default:
        return setText(PRIVATE_GDPR_TEXT)
    }
  }, [type])

  return (
    <GdprMessageWrapper data-testid="channel-gdpr-message">
      <TextCallout2>{text}</TextCallout2>
      <UnderlineLink
        href="https://vend.com/privacy/se-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Läs mer här
      </UnderlineLink>
    </GdprMessageWrapper>
  )
}

ChannelGdprMessage.propTypes = {
  type: PropTypes.string,
}

export default ChannelGdprMessage
